import {createReducer} from "redux-act";
import {setBETimeDiff} from "modules/actions";

const defaultState = {be_time_diff: 0};

export type ITimeReducer = typeof defaultState;

export const time = createReducer<ITimeReducer>({}, defaultState).on(
	setBETimeDiff,
	(state, be_time_diff) => ({
		...state,
		be_time_diff,
	})
);
